export const settings = {
    travelizeLanguage: 'de_DE',
    modules: {
        websiteExport: false,
        webflow: true,
        ai: true,
        todoEmailNotification: true,
        // Gedankenaufnahme (Aufnahme-Knopf im Header, Fenster /recorder)
        recording: true,
    },
    general: {
      resetFilter : false,
    },
    pagination: {
        order_concepts: {
            perPage: 80
        }
    },
    otherServiceTypes: {
        locationSpecificCategories: ['restaurant'],
    },
    crud: {
        mergeStatus: true,
        menus: {
            tipTap: {
                maxLines: 0,
                maxCharacters: 0,
            },
            defaultOtherServiceTypeId: 41
        },
        clients: {
            list: {
                general: {
                    //[
                    //                     { key: 'id', label: 'Nr', class: 'is-small-cell' },
                    //                     { key: 'companyName', label: 'Kundenname', class: 'is-one-fifth' },
                    //                     { key: 'zip', label: 'PLZ', sortable: 'addresses.zip', filter: 'addresses.zip'},
                    //                     { key: 'addresses', label: 'Ort', filter: 'addresses', sortable: 'addresses.city'},
                    //                     { key: 'addressCountry', label: 'Land', filter: 'addresses.country', sortable: 'addresses.country'},
                    //                     { key: 'importance', sortable: 'importance', filter: 'importance'},
                    //                     'url',
                    //                     { key: 'traitTags', sortable: false, label: 'Tags', class: 'is-one-tenth', filter: 'traitTags'},
                    //                     { key: 'mainUsers', filter: 'mainUsers.id'},
                    //                     { key: 'receivesCatalog', filter:  'receivesCatalog'},
                    //                     { key: 'dataCheckedAt',},
                    //                 ]
                    columns: [
                        { key: 'id', label: 'Nr', class: 'is-small-cell' },
                        { key: 'companyName', label: 'Kundenname', class: 'is-one-fifth' },
                        { key: 'zip', label: 'PLZ', sortable: 'addresses.zip', filter: 'addresses.zip'},
                        { key: 'addresses', label: 'Ort', filter: 'addresses', sortable: 'addresses.city'},
                        { key: 'addressCountry', label: 'Land', filter: 'addresses.country', sortable: 'addresses.country'},
                        { key: 'importance', sortable: 'orders'},
                        'url',
                        { key: 'traitTags', sortable: false, label: 'Tags', class: 'is-one-tenth', filter: 'traitTags'},
                        { key: 'mainUsers'},
                        { key: 'receivesCatalog', filter:  'receivesCatalog'},
                        { key: 'mergeStatus', label: 'Quelle', sortable: true},
                    ],
                    filterKeys: ['category', 'paymentType', 'destinations'],
                    extraFilters: [
                        {
                            key: 'mainUsers.id',
                            params: {
                                'username[not]': ['Julien', 'Accounting']
                            }
                        },
                        {
                            key: 'importance',
                        }
                    ]
                },
                sales: {
                    columns: [
                        { key: 'id', label: 'Nr', class: 'is-small-cell' },
                        { key: 'companyName', label: 'Kundenname', class: 'is-one-fifth' },
                        { key: 'importance[-1]', cellKey: 'importance', label: 'Wichtigkeit [t-1]', sortable: false},
                        { key: 'importance[0]', cellKey: 'importance', label: 'Wichtigkeit [t]', sortable: false},
                        { key: 'importance[1]', cellKey: 'importance', label: 'Wichtigkeit [t+1]', sortable: false},
                        { key: 'revenues[-1]', label: 'Umsatz [t-1]', sortable: false},
                        { key: 'revenues[0]', label: 'Umsatz [t]', sortable: false},
                        { key: 'revenues[1]', label: 'Umsatz [t+1]', sortable: false},
                        { key: 'bookingRatio[-1]', label: 'Conversion Rate [t-1]', sortable: false},
                        { key: 'bookingRatio[0]', label: 'Conversion Rate [t]', sortable: false},
                        { key: 'bookingRatio[1]', label: 'Conversion Rate [t+1]', sortable: false},
                        { key: 'lastClientVisit', label: 'Letzter Kundenbesuch'},
                        { key: 'mergeStatus', label: 'Quelle', sortable: true},
                    ],
                    filterKeys: ['addresses.zip', 'addresses.city', 'addresses.country', 'traitTags', 'receivesCatalog', 'category', 'hasLinkedIn', 'paymentType', 'destinations'],
                    extraFilters: [
                        {
                            key: 'salesUsers.id',
                            params: {
                                'username[not]': ['Julien', 'Accounting']
                            }
                        },
                        {
                            key: 'importance',
                        }
                    ]
                }
            }

        }
    },
    request: {
        // Tag to check when changing status to 'canceled'. If empty/null, the feature is disabled.
        stornoCheckTag: 'stornierung',
    },
    tripDetails: {
        mergePanel: false,
    },
    order: {
        useTagsForCommission: true,
        // Fahrzeugtyp der Reise (Bus/Auto/Minibus) + Km/über/Fahrzeit je Fahrzeug und Tageszeit im
        // Stamm-Routenstichpunkt; ersetzt in der Reise das Tageszeit-Feld (vormittags…). Aktiv bei rstours.
        vehicleType: { show: false },
        complexity: {
            offerComplexity: { show: true, required: false },
            operationComplexity: { show: true, required: false },
            clientComplexity: { show: true, required: false },
            rentability: { show: true, required: false },
            bookingProbability: { show: true, required: false },
            executionProbability: { show: true, required: false },
        },
        tripDashboard: {
            showRouteDetailStatuses: ['new','offer_revision'],
            rightPanel: {
                additionalFields: [
                    {
                        property: 'welcomeOrderId',
                        title: 'Welcome Tours Reise Nr',
                        icon: 'computer',
                        isInEditMode: false
                    },
                ]
            }
        },
        contacts:  {
            hideBus: true,
        },
        modal: {
            assignedContactAddress: false,
        },
        placeholderForms: {
            other: {
                requiresDriverIsNotParticipating: []
            },
            ferry: {
                requiresDriverIsNotParticipating: []
            },
            train: {
                requiresDriverIsNotParticipating: []
            }
        },
        navigation: [
            {url: '', label: 'Reisemaske', showOnSmall : true},
            {url: 'services', label: 'Hotelübersicht'},
            {url: 'calculations', label:  'Kalkulation', showOnSmall : true},
            {url: 'offer', label: 'Angebot'},
            {url: 'catalog', label: 'Katalogtext'},
/*            {url: 'menus', label: 'Menüs'},*/
            {url: 'roomlist', label: 'Zimmerliste'},
            {url: 'trip-details', label: 'Reiseunterlagen'},
            {url: 'voucher', label: 'Voucher'},
            {url: 'client-invoice', label: 'Kundenrechnung'},
            {url: 'invoices', label: 'Zahlungen an LT'},
            {url: 'documents', label: 'Dokumente'},
            {url: 'emails', label: 'Emails'},
        ],
    },
    offer: {
        tabs: {
            offer: true,
            freePlaces : true,
            cancelation: true,
            payments: true,
            conditions: false,
            other: true,
        },
        freePlaces: {
            showRoomType: true
        },
        bullets: {
            show: true
        },
        generationTypes: {},
    },
    userDashboard: {
        resetFilterToToday: true,
        todoSorting: {
            //'_custom_order[todoType]': ['phone', 'visit'],
            '_custom_order[dueDate]': 'asc',
            '_custom_order[todoType]': ['phone', 'visit'],
            '_custom_order[type]': ['external', 'internal'],
            '_custom_order[order.startAt]': 'asc',
        },
    },
    emails: {
        organisationHosts : ['@buspaket.de', '@we-tours.com', '@we-tours.de', '@eurobin.de', '@welcome-tours.com'],
        isFormal: {
            client: false,
            provider: true,
        },
        selectedIsFormal: {
            client: true,
            provider: false,
        },
        categories: {
            client : {
                icon: "folder",
                value: "client",
                label: "client",
                standardClient : true,
                standardProvider: false,
            },
            provider: {
                icon: "hotel",
                value: "provider",
                label: "provider",
                standardClient : false,
                standardProvider: true,
            }
        }
    },
    calculation: {
        singleRoomLimit: 'always',
        startView : 'table',
        extraBlocks: [
            {
                offerTextBlock: 'hotelSuplements',
                label: 'Mehrbettzimmer und sonstige Zimmer',
            },
            {
                offerTextBlock: 'ferrySuplements',
                label: 'Außenkabinen',
            },
            {
                offerTextBlock: 'trainSuplements',
                label: 'Zugfahrten 1. Klasse',
            },
            {
                offerTextBlock: 'ferryOther',
                label: 'zusätzliche Leistungen an Bord der Fähre',
            },
            {
                offerTextBlock: 'foodOnBoard',
                label: 'zusätzliche Leistungen an Bord der Fähre',
            },
            {
                offerTextBlock: 'tourGuides',
                label: 'zusätzliche Reiseleiter-Leistungen',
            },
            {
                offerTextBlock: 'groupServices',
                label: 'zusätzliche Gruppen-Leistungen',
            },
            {
                offerTextBlock: 'services',
                label: 'zusätzliche Leistungen pro Person',
            },
            {
                offerTextBlock: 'mainPriceDates',
                label: 'Paketpreise',
            },
            {
                offerTextBlock: 'tax',
                label: 'Kurtaxe',
            },

        ],
    },
    providerInvoice: {
        hasInvoiceDetails: false,
        startSection: 'InvoiceList',
        disableCompleted: true,
        output: 'pdf',
        setStatusAtDownload: null,
        allowedStatusSequence: {
            'sent_for_payment': ['paid', 'cancelled'],
            'paid': ['completed', 'cancelled', 'sent_for_payment'],
            'completed': ['paid'],
            'cancelled': ['sent_for_payment']
        },
        form: {
            issuer: true,
            bankAccount: true,
            type: 'final_payment',
            invoiceCurrency: true,
            invoiceAmount: true,
            invoiceNumber: true,
            invoiceDate: true,
            dueDate: true,
            status: false,
            notes: true,
            document: true,
            organisationBankAccount: false,
            checkNumber: false,
            paymentReceiptRequired: false,
            user: false,
            paymentType: true,
        },
        formDefaultValues: {},
        formValidations: [
            'invoiceNumber',
            'invoiceAmount',
            'invoiceDate',
            'bankAccount',
            'document',
        ],
        paymentForm: {
            paymentDate: true,
            bankAccount: true,
            accountPlanItem: true,
            paymentReceipt: true,
        },
        createInvoice: {
            filters: {
                requestStatuses: ['pre_booked', 'option_received', 'option', 'rest_request', 'bookings_sent', 'order_uncertain', 'room_list', 'rest_option', 'approved', 'paid']
            }
        },
        invoiceList: {
            statusesSelected: ['sent_for_payment', 'payment_in_process', 'paid', 'completed'],
        },
        tabs: [
            { key: 'OpenAmountList', label: 'Offene Beträge LT'},
            { key: 'PaymentList', label: 'Bezahlte Rechnungen LT'},
            { key: 'InvoiceList', label: 'Rechnungen von LT'},
        ],
        columns: [
            { key: 'checkable', label:  '', class: 'is-icon-cell  is-relative', style:'padding: 0px; justify-content: center;'},
            { key: 'favicon', formElement: 'Favicon', label: 'User', class: 'is-user-cell has-text-centered has-border is-hidden-on-small'},
            { key: 'invoiceNumber', label: 'R-Nr', class: 'is-160px-cell has-border is-pure-text', formElement: 'PureText'},
            { key: 'tripLabel', label:  'Reisen', class: ' has-border is-pure-text', formElement: 'tripLabel'},
            { key: 'info.issuer', label:  'Rechnungssteller', class: 'has-border is-pure-text', formElement: 'PureText'},
            { key: 'bankIcons', label:  'Bankverbindung', class: 'is-160px-cell has-border is-pure-text is-hidden-on-small', formElement: 'bankIcons'},
            { key: 'invoiceAmount.currency', label: 'CUR', class: 'is-40px-cell has-border has-text-centered is-pure-text', formElement: 'PureText' },
            { key: 'invoiceAmount.numberFormatted', label:  'R-Betrag', class: 'is-110px-cell is-pure-text is-right has-border', formElement: 'PureText' },
            { key: 'invoiceDate', label:  'R-Datum', class: 'is-date-cell is-pure-text has-text-centered has-border is-hidden-on-small', formElement: 'PureText', props: {isDate: true} },
            { key: 'dueDateTransformed', label: 'Zahlungsziel', class: 'is-110px-cell has-border has-text-centered', formElement: 'InputDateTable', props: {onlyDate: false, showDeadlineUrgency: true, readOnly: true} },
            { key: 'paymentDate', label: 'Bezahlt am', class: 'is-date-cell is-pure-text has-text-centered has-border is-hidden-on-small', formElement: 'PureText', props: {isDate: true} },
            { key: 'status', label: 'Status', class: 'is-110px-cell is-editable has-border-head', formElement: ''},
            { key: 'aiCheck', label: 'KI', class: 'is-small-cell has-text-centered has-border', formElement: ''},
            { key: 'document', label: 'Zahlungsbeleg', class: 'is-135px-cell has-text-centered has-border', formElement: ''},
            { key: 'paymentType', label:  'Abbuchung', class: 'is-110px-cell has-text-centered has-border is-hidden-on-small', formElement: '' },
            { key: 'notes', label:  'Notizen', class: 'is-small-cell has-text-centered has-border is-hidden-on-small', formElement: 'PureText' },
        ],

        subColumns: [
            { key: 'empty-checkable', label:  '', class: 'is-icon-cell  is-relative', formElement: '',style:'padding: 0px; justify-content: center;'},
            { key: 'empty-favicon', label: '', class: 'is-user-cell has-text-centered has-border is-hidden-on-small', formElement: ''},
            { key: 'empty-invoiceNumber', label: 'Rechnungspositionen', class: 'is-160px-cell has-border is-pure-text', formElement: 'PureText'},
            { key: 'clientLabel', label:  'Reise', class: 'has-border is-pure-text', formElement: 'tripLabel'},
            { key: 'serviceDescription', label: 'Leistung', class: 'has-border is-pure-text', formElement: 'PureText'},
            { key: 'startEndAt', label:  'Datum', class: 'is-160px-cell has-border is-pure-text is-hidden-on-small', formElement: 'PureText', props: {isDate: true}},
            { key: 'invoiceVars.amountDue.currency', label: 'CUR', class: 'is-40px-cell has-border has-text-centered is-pure-text', formElement: 'PureText'},
            { key: 'invoiceVars.amountDue.numberFormatted', label:  'Betrag', class: 'is-110px-cell is-pure-text is-right has-border', formElement: 'PureText' },
            { key: 'empty-invoiceDate', label:  '', class: 'is-date-cell is-pure-text has-text-centered has-border is-hidden-on-small', formElement: 'PureText'},
            { key: 'empty-dueDateTransformed', label: '', class: 'is-110px-cell has-border has-text-centered', formElement: '' },
            { key: 'empty-paymentDate', label: '', class: 'is-date-cell is-pure-text has-text-centered has-border is-hidden-on-small', formElement: 'PureText' },
            { key: 'empty-status', label: '', class: 'is-110px-cell is-editable has-border-head', formElement: ''},
            { key: 'empty-aiCheck', label: '', class: 'is-small-cell has-text-centered has-border', formElement: ''},
            { key: 'empty-document', label: '', class: 'is-135px-cell has-text-centered has-border', formElement: ''},
            { key: 'empty-paymentType', label:  '', class: 'is-110px-cell has-text-centered has-border is-hidden-on-small', formElement: '' },
            { key: 'empty-notes', label:  '', class: 'is-small-cell has-text-centered has-border is-hidden-on-small', formElement: 'PureText' },
        ],
        columnsShorter: [
            { key: 'invoiceNumber', label: 'R-Nr', class: 'is-160px-cell has-border is-pure-text', formElement: 'PureText'},
            { key: 'info.issuer', label:  'Rechnungssteller', class: 'has-border is-pure-text', formElement: 'PureText'},
            { key: 'bankIcons', label:  'Bankverbindung', class: 'is-160px-cell has-border is-pure-text is-hidden-on-small', formElement: 'bankIcons'},
            { key: 'invoiceAmount.currency', label: 'CUR', class: 'is-40px-cell has-border has-text-centered is-pure-text', formElement: 'PureText' },
            { key: 'invoiceAmount.numberFormatted', label:  'R-Betrag', class: 'is-110px-cell is-pure-text is-right has-border', formElement: 'PureText' },
            { key: 'invoiceDate', label:  'R-Datum', class: 'is-date-cell is-pure-text has-text-centered has-border', formElement: 'PureText', props: {isDate: true} },
            { key: 'dueDateTransformed', label: 'Zahlungsziel', class: 'is-110px-cell has-border has-text-centered is-hidden-on-small', formElement: 'InputDateTable', props: {onlyDate: false, showDeadlineUrgency: true, readOnly: true} },
            { key: 'paymentDate', label: 'Bezahlt am', class: 'is-date-cell is-pure-text has-text-centered has-border is-hidden-on-small', formElement: 'PureText', props: {isDate: true} },
            { key: 'status', label: 'Status', class: 'is-110px-cell is-editable has-border-head', formElement: ''},
            { key: 'aiCheck', label: 'KI', class: 'is-small-cell has-text-centered has-border', formElement: ''},
            { key: 'document', label: 'Zahlungsbeleg', class: 'is-135px-cell has-text-centered has-border', formElement: ''},
            { key: 'paymentType', label:  'Abbuchung', class: 'is-110px-cell has-text-centered has-border is-hidden-on-small', formElement: '' },
            { key: 'notes', label:  'Notizen', class: 'is-small-cell has-text-centered has-border is-hidden-on-small', formElement: 'PureText' },
        ],
        subColumnsShorter: [
            { key: 'empty-invoiceNumber', label: 'Rechnungspositionen', class: 'is-160px-cell has-border is-pure-text', formElement: 'PureText'},
            { key: 'serviceDescription', label: 'Leistung', class: 'has-border is-pure-text', formElement: 'PureText'},
            { key: 'startEndAt', label:  'Datum', class: 'is-160px-cell has-border is-pure-text is-hidden-on-small', formElement: 'PureText', props: {isDate: true}},
            { key: 'invoiceVars.amountDue.currency', label: 'CUR', class: 'is-40px-cell has-border has-text-centered is-pure-text', formElement: 'PureText'},
            { key: 'invoiceVars.amountDue.numberFormatted', label:  'Betrag', class: 'is-110px-cell is-pure-text is-right has-border', formElement: 'PureText' },
            { key: 'empty-invoiceDate', label:  '', class: 'is-date-cell is-pure-text has-text-centered has-border', formElement: 'PureText'},
            { key: 'empty-dueDateTransformed', label: '', class: 'is-110px-cell has-border has-text-centered is-hidden-on-small', formElement: '' },
            { key: 'empty-paymentDate', label: '', class: 'is-date-cell is-pure-text has-text-centered has-border is-hidden-on-small', formElement: 'PureText' },
            { key: 'empty-status', label: '', class: 'is-110px-cell is-editable has-border-head', formElement: ''},
            { key: 'empty-aiCheck', label: '', class: 'is-small-cell has-text-centered has-border', formElement: ''},
            { key: 'empty-document', label: '', class: 'is-135px-cell has-text-centered has-border', formElement: ''},
            { key: 'empty-paymentType', label:  '', class: 'is-110px-cell has-text-centered has-border is-hidden-on-small', formElement: '' },
            { key: 'empty-notes', label:  '', class: 'is-small-cell has-text-centered has-border is-hidden-on-small', formElement: 'PureText' },
        ],
        subColumnsShorter2: [
            { key: 'serviceDescription', label: 'Leistung', formElement: 'PureText',  class:"is-250px-cell", style:"padding:0 6px;", props: {baseUrl: '/orders/'}, evalProps: {urlId: 'orderId'} },
            { key: 'invoiceVars.amountDue.currency', label: '', class:"is-70px-cell", style:"padding:0 6px;", formElement: 'PureText' },
            { key: 'invoiceVars.amountDue.numberFormatted', label:  'Gesamtkosten', class:"is-150px-cell", style:"padding:0 6px;", formElement: 'PureText' },
            { key: 'invoiceVars.startAt', label:  'Beginn', class:"is-150px-cell", style:"padding:0 6px;", formElement: 'PureText', props: {isDate: true} },
            { key: 'invoiceVars.endAt', label: 'Ende', class:"is-150px-cell", style:"padding:0 6px;", formElement: 'PureText', props: {isDate: true} },
            { key: 'empty-2', label: '', class:"is-60px-cell", style:"padding:0 6px;", formElement: 'PureText' },
            { key: 'empty-3', label:  '', class:"", formElement: 'PureText' },
            { key: 'empty-4', label:  '', formElement: 'PureText' },
            { key: 'empty-5', label:  '', class: '',style:'max-width: 83px;', formElement: '' },
        ]
    },
    emailTemplate: {
        startSection: 'Templates'
    },
    clientInvoice: {
        disableCompleted: true,
        docType: 'pdf',
        fields: {
            tax: [
                {
                    value: 0,
                    isSpecial: false,
                    label: '0 %',
                    accountingNumber: 3010,
                },
                {
                    value: 3.8,
                    isSpecial: false,
                    label: '3.8 %',
                    accountingNumber: null,
                },
                {
                    value: 8.1,
                    isSpecial: false,
                    label: '8.1 %',
                    accountingNumber: 3011,
                },
                {
                    value: 3.7,
                    isSpecial: false,
                    label: '3.7 %',
                    accountingNumber: null,
                },
                {
                    value: 7.7,
                    isSpecial: false,
                    label: '7.7 %',
                    accountingNumber: 3011,
                },
            ],
            invoiceDate: true,
            calculationBasis: true,
            dueDate: true,
            contact: false,
            introText: false,
            endText: true,
            signature: true
        },
        columns: [
            { key: 'favicon', label: 'User', class: 'is-user-cell', sortable: 'order.user.username' },
            { key: 'invoiceNumber', filter: 'invoiceNumber', label: 'R-NR', sortable: 'invoiceNumberNumeric', title: 'Nach Nummer sortieren (Präfix wird ignoriert)' },
            { key: 'typeLabel', label: 'Art' },
            { key: 'order', filter: 'order.id', label: 'Reisenummer' },
            { key: 'order.client.shortName', label: 'Kunde', class: 'is-180px-cell' },
            { key: 'order.trip.name', label: 'Reiseziel', class: 'is-180px-cell' },
            { key: 'order.startAt', label: 'Reisebeginn'},
            { key: 'order.endAt', label: 'Reiseende'},
            { key: 'invoiceDate', filter: 'invoiceDate', label: 'Rechnungsdatum'},
            { key: 'dueDate', filter: 'dueDate', label: 'Zahlungsziel', class: 'is-120px-cell is-editable', showSum: 'Summe'},
/*
            { key: 'order.totalExpectedRevenues.numberFormatted', label: 'Aktuell', class: 'has-text-right', showSum: 'price' },
*/
            // Stand der Reise nach dieser Rechnung (ClientInvoiceBalanceService): alles bis hierhin in Rechnung Gestellte
            // bzw. Bezahlte, so wie es auf der Rechnung steht. Summiert wird nur die aktuelle Rechnung je Reise.
            { key: 'orderInvoicedAmount.formatted', label: 'Gesamtbetrag', class: 'is-120px-cell', showSum: 'price', title: 'Alles bis einschließlich dieser Rechnung in Rechnung Gestellte' },
            { key: 'orderPaidAmount.formatted', label: 'Bezahlt', class: 'is-120px-cell', showSum: 'price', title: 'Alle Zahlungen bis einschließlich dieser Rechnung' },
            // Saldo der ganzen Reise, nur an der aktuellen Rechnung
            { key: 'orderBalance.formatted', label: 'Saldo (Reise)', class: 'is-120px-cell', showSum: 'price'},
            { key: 'status', filter: 'status', label: 'Status', hideContent: true, class: 'is-medium-cell is-editable '},
        ],
        orderBy: {
            '_order[order.organisationFilter.id]': 'ASC',
            '_order[invoiceDate]': 'DESC',
            // bei gleichem Rechnungsdatum nach Rechnungsnummer: die wird beim Erstellen fortlaufend vergeben, also id
            // (invoiceNumberNumeric ginge hier nicht, eigene Sortierfilter laufen in API Platform vor dem OrderFilter)
            '_order[id]': 'DESC',
        },
        mainCurrency: 'EUR',
        exportCurrentInvoice: ['standard', 'noHeader'],
    },
    voucher: {
        translations: true,
        translationsInOne: true,
        aiTranslation: true,
        availableTranslations: ['de_DE', 'fr', 'en'],
        translationDelimiter: " / \n",
        hasInternalVoucher: false,
        tipTap: {
            maxCharacters: 40,
        },
        printModeOptions: [
            {
                label: 'mit unserem Logo',
                value: 'withLogo'
            },
            {
                label: 'mit BTO Logo',
                value: 'btoLogo'
            },
        ],
    },
    roomList: {
        create: {
            fields: {
                notes: true
            }
        },
        types: [
            {key: 'templateA', label: 'Zimmerliste', default: true},
            {key: 'templateB', label: 'Passagierliste', default: false},
            {key: 'templateC', label: 'Passagierliste mit Motorrad', default: false},
        ],
        templateA: {
            fields: {
                extraType: true,
                twin: true,
                gender: false,
                firstName1: false,
                lastName: true,
                firstName2: true,
                nationality: false,
                dateOfBirth: false,
                placeOfBirth: false,
                birthCountry: false,
                documentType: false,
                documentNumber: false,
                assistance: false,
                outsideCabin: false,
                notes: true
            }
        },
        templateB: {
            fields: {
                extraType: true,
                twin: false,
                gender: true,
                firstName1: false,
                lastName: true,
                firstName2: true,
                nationality: true,
                dateOfBirth: true,
                placeOfBirth: true,
                birthCountry: true,
                documentType: true,
                documentNumber: true,
                passExpirationDate: true,
                assistance: true,
                outsideCabin: true,
                notes: true
            }
        },
        templateC: {
            fields: {
                extraType: true,
                twin: false,
                gender: true,
                firstName1: true,
                lastName: true,
                firstName2: false,
                nationality: true,
                dateOfBirth: true,
                placeOfBirth: true,
                birthCountry: true,
                documentType: true,
                documentNumber: true,
                passExpirationDate: true,
                assistance: true,
                outsideCabin: true,
                notes: true,
                motorBikeModel: true,
                licencePlate: true
            }
        },
        sources: [
                {label: 'KI', key: 'ki', default: true},
                {label: 'Buspaket kurz', key: 'buspaket_short', default: false},
                {label: 'Buspaket', key: 'buspaket', default: false},
                {label: 'Toeffreisen', key: 'toeffreisen', default: false},
                {label: 'Reisen & Erleben', key: 'reisenUndErleben', default: false},
            ]
    },
    liquidityPlan: {
        isUsed: true,
        customExports: [
            {
                fileType: '.xlsx',
                active: true,
                type: 'monthly',
                label: 'V & V erstellen',
                url: '/api/finances/custom-statement/generate-excel',
                downloadName: 'Vermietung und Verpachtung Kirchheim'
            },
            {
                fileType: '.xlsx',
                active: true,
                type: 'yearly',
                label: 'UmSt Vergütung',
                url: '/api/finances/custom-tva-statement/generate-excel',
                downloadName: 'Umsatzsteuervergütung'
            },
            {
                fileType: '.xlsx',
                active: true,
                type: 'yearly',
                label: 'UmSt Vergütung CSV',
                url: '/api/finances/custom-tva-statement/generate-csv',
                downloadName: 'Umsatzsteuervergütung'
            }
        ],
    },
    statisticsDashboard: {
        // Organisations shown in the dashboard graphs and tables, in this order (Buspaket, we tours, Welcome Tours,
        // Eurobin Trading - its trips moved to we tours in 2026, but last year's count for the totals)
        organisationIds: [1, 2, 3, 4],
        // organisation id => organisation whose trips it took over: year-over-year changes compare the new one
        // with both together (Eurobin Trading's trips run under we tours since 2026)
        mergedInto: {4: 2},
        // colour per organisation (rows of the overview table, see statistics.scss .is-cluster-*)
        colors: {1: 'blue', 2: 'green', 3: 'orange', 4: 'green'},
        // destination groups (ClientConfig statistics.destinationGroups) per organisation that sells them, in the order
        // of the table; '*' takes all other groups
        destinationClusters: [
            {organisationId: 1, groups: ['korsika', 'sardinien', 'sizilien', 'elba', 'iberien']},
            {organisationId: 3, groups: ['frankreich']},
            {organisationId: 2, groups: '*'},
        ],
    },

};

